const JUNIOR_HIGH_ACADEMIC_YEARS: readonly number[] = [1, 2, 3]

export { JUNIOR_HIGH_ACADEMIC_YEARS }
